import type { Patient as PatientResource } from "@curai/js-fhir-tools";

/**
 * Checks if a patient is a Universal Clinic Patient.
 * Universal Clinic Patients have the UniversalClinicPatient profile in their meta.
 */
export const isUniversalClinicPatient = (
  patient?: PatientResource,
): boolean => {
  return (
    patient?.meta?.profile?.includes(
      "https://fhir-ig.curaihealth.com/StructureDefinition/UniversalClinicPatient",
    ) ?? false
  );
};
